import { Node as ContentNode } from 'prosemirror-model';

/**
 * Returns the position before consecutive spaces in a ProseMirror document.
 */
export const getPositionBeforeSpaces = (doc: ContentNode, currentPos: number) => {
    let pos = currentPos;

    // Move back until we find a non-space character or reach the start of the document
    while (pos > 1 && doc.textBetween(pos - 1, pos, undefined, 'N/A') === ' ') {
        pos -= 1;
    }

    return pos;
};
